export default __webpack_public_path__ + "static/media/week-6-img.182b81f0.png";